import { openBlock as e, createElementBlock as r, createElementVNode as o } from "vue";
function c(t, n) {
  return e(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 12H5m0 0l7 7m-7-7l7-7"
    })
  ]);
}
export {
  c as default
};
//# sourceMappingURL=highrise.es359.js.map
